// Self-hosted Poppins (the same five weights apps/mobile loads). The .ttf imports resolve to URLs; the package has
// no exports map, so the deep paths work. fontStyle() in @kk/ui emits fontFamily 'Poppins' + a numeric weight on web.
import p400 from '@expo-google-fonts/poppins/400Regular/Poppins_400Regular.ttf';
import p500 from '@expo-google-fonts/poppins/500Medium/Poppins_500Medium.ttf';
import p600 from '@expo-google-fonts/poppins/600SemiBold/Poppins_600SemiBold.ttf';
import p700 from '@expo-google-fonts/poppins/700Bold/Poppins_700Bold.ttf';
import p800 from '@expo-google-fonts/poppins/800ExtraBold/Poppins_800ExtraBold.ttf';

const faces: ReadonlyArray<readonly [number, string]> = [
  [400, p400],
  [500, p500],
  [600, p600],
  [700, p700],
  [800, p800],
];

/** How long the first paint waits for Poppins before failing open (the mobile gate waits on the splash). */
export const FONT_GATE_TIMEOUT_MS = 3000;

export async function loadAppFonts(): Promise<void> {
  if (typeof FontFace === 'undefined' || !('fonts' in document)) return;
  await Promise.all(
    faces.map(async ([weight, url]) => {
      const face = new FontFace('Poppins', `url(${url})`, {
        weight: String(weight),
        display: 'block',
      });
      document.fonts.add(await face.load());
    }),
  );
}

/** Resolves when the fonts are in or the timeout passes — never rejects, so a font failure is visible, not fatal. */
export function fontGate(timeoutMs = FONT_GATE_TIMEOUT_MS): Promise<void> {
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, timeoutMs));
  return Promise.race([
    loadAppFonts().catch((e: unknown) => {
      if (__DEV__)
        console.error('[fonts] Poppins failed to load; falling back to the system font', e);
    }),
    timeout,
  ]);
}
